import i18n from "../../../i18n";import { Trans } from "react-i18next";import { Search } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue } from
"../../../components/ui/select";

export function HolidayFilterBar({
  search,
  setSearch,
  typeFilter,
  setTypeFilter,
  visibilityFilter,
  setVisibilityFilter,
  typeOptions = [],
  departments = [],
  locations = [],
  scopeFilter,
  setScopeFilter
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 bg-white border border-[var(--color-text-border)]/70 rounded-2xl px-4 py-3">
      <div className="flex-1 flex items-center gap-2 min-w-0">
        <Search className="h-4 w-4 text-[var(--color-text-secondary)] shrink-0" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={i18n.t("formActions.searchRecords")}
          className="w-full border-none outline-none bg-transparent text-sm text-foreground placeholder:text-muted-foreground" />
        
      </div>

      <Select value={typeFilter} onValueChange={setTypeFilter}>
        <SelectTrigger className="h-10 w-full sm:w-[180px] rounded-xl border-[var(--color-text-border)] bg-white text-sm font-medium">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="All types"><Trans i18nKey="common.allTypes" /></SelectItem>
          {typeOptions.map((cat) =>
          <SelectItem key={cat.categoryId} value={cat.categoryName}>
              {cat.categoryName}
            </SelectItem>
          )}
        </SelectContent>
      </Select>

      <Select
        value={visibilityFilter}
        onValueChange={(v) => {
          setVisibilityFilter(v);
          setScopeFilter("");
        }}>
        
        <SelectTrigger className="h-10 w-full sm:w-[190px] rounded-xl border-[var(--color-text-border)] bg-white text-sm font-medium">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="All visibility"><Trans i18nKey="holidays.allVisibility" /></SelectItem>
          <SelectItem value="Global"><Trans i18nKey="holidays.global" /></SelectItem>
          <SelectItem value="Department"><Trans i18nKey="common.department" /></SelectItem>
          <SelectItem value="Work Location"><Trans i18nKey="holidays.workLocation" /></SelectItem>
        </SelectContent>
      </Select>

      {visibilityFilter === "Department" &&
      <Select value={scopeFilter} onValueChange={setScopeFilter}>
          <SelectTrigger className="h-10 w-full sm:w-[190px] rounded-xl border-[var(--color-text-border)] bg-white text-sm font-medium">
            <SelectValue placeholder={i18n.t("holidays.allDepartments")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all"><Trans i18nKey="holidays.allDepartments" /></SelectItem>
            {departments.map((d) =>
          <SelectItem key={d.departmentId} value={String(d.departmentId)}>
                {d.departmentName}
              </SelectItem>
          )}
          </SelectContent>
        </Select>
      }

      {visibilityFilter === "Work Location" &&
      <Select value={scopeFilter} onValueChange={setScopeFilter}>
          <SelectTrigger className="h-10 w-full sm:w-[190px] rounded-xl border-[var(--color-text-border)] bg-white text-sm font-medium">
            <SelectValue placeholder={i18n.t("holidays.allLocations")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all"><Trans i18nKey="holidays.allLocations" /></SelectItem>
            {locations.map((l) =>
          <SelectItem key={l.workLocationId} value={String(l.workLocationId)}>
                {l.workLocationName}
              </SelectItem>
          )}
          </SelectContent>
        </Select>
      }
    </div>);

}
